<template>
  <div class="container">
    <h3>Win版Anymo下载会提示提示软件信任问题</h3>
    <p>解决方法如下：</p>
    <p>1.页面弹窗的右上角的三个点，选择保留即可：</p>
    <p><img src='/static/image/win.png' width="350px"/></p>
    <div class="h-200"></div>
  </div>
</template>

<script>


export default {
  name: "Max",
  data() {
    return {}
  },
  mounted() {

  }
}
</script>

<style scoped>
.container {
  width: 85%;
  max-width: 600px;
  margin: 30px auto 0;
  padding: 2% 5%;
  border-radius: 10px
}

ul {
  padding-left: 20px;
}

ul li {
  line-height: 2.3
}

a {
  color: #20a53a
}
</style>
